<template>
    <div>
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">{{ $t('descricao') }} - {{ $t('agro-sugestao') }}</h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table v-else :data="sugestao" class="data-table" @sort="sortTable" backend-sorting>
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'descricao'" class="pre-line">
                        <a @click="sugestaoSelect(props.row[f.key])">
                            {{ props.row[f.key] }}
                        </a>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import sugestaoService from '@/services/agro/SugestaoService';

export default {
    data() {
        return {
            service: new sugestaoService(this.$http, this.$router),
            sugestao: [],
            isLoading: false,
            isEmpty: false,
            fields: [{ key: 'descricao', width: null, sortable: true, sortFn: null }],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [5, 10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            showModal: false,
            situacao: 1,
            usuarioETodos: 1,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            let params = [
                this.queryFilter != '' ? this.queryFilter : '.*',
                // Usuário logado
                this.$store.state.user.usuario.id,
                // Origem
                'agro_visitarecomendacao_descricaogeral',
                // Usuário e todos
                this.usuarioETodos,
            ];

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.sugestao = Object.assign(value);
                    this.isEmpty = this.sugestao.length == 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    descricao: m.descricao,
                    id: m.id,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sugestaoSelect(selected) {
            this.$emit('selected', selected);
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
.pre-line {
    white-space: pre-line;
}
.search-and-filter {
    .search-bar {
        width: 100%;
    }
    @media (max-width: 760px) {
        .search-bar {
            padding-right: 0;
        }
    }
}
</style>
